import React from 'react';
import {
  Cctv, Volume2, FlaskConical, CloudSun, Zap, Dumbbell, Droplet,
  Thermometer, Users, Boxes, Compass,
} from 'lucide-react';

function SensorTypeIcon({ sensorType, size }: SensorTypeIconProps) {
  function getIcon(st: string) {
    switch (st) {
      case 'camera':
        return <Cctv size={size} />;
      case 'sound':
        return <Volume2 size={size} />;
      case 'chemical':
        return <FlaskConical size={size} />;
      case 'climate':
        return <CloudSun size={size} />;
      case 'electrical':
        return <Zap size={size} />;
      case 'pressure':
        return <Dumbbell size={size} />;
      case 'liquid':
        return <Droplet size={size} />;
      case 'temperature':
        return <Thermometer size={size} />;
      case 'presence':
        return <Users size={size} />;
      case 'density':
        return <Boxes size={size} />;
      case 'position':
        return <Compass size={size} />;
      default:
        return null;
    }
  }

  return (
    <div className="w-5 content-center text-center">
      {getIcon(sensorType)}
    </div>
  );
}

type SensorTypeIconProps = {
  sensorType: string
  size: number
};

export default SensorTypeIcon;
